module.exports = __webpack_public_path__ + "static/media/dot-arrow-svgrepo-com.7b02c6e4.svg";